module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "scale-svg",
    attrs: {
      "width": "3082px",
      "height": "570px",
      "viewBox": "0 0 3082 570"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "transform": "translate(2362.000000, 120.000000)"
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#F9C993",
      "x": "0",
      "y": "0",
      "width": "520",
      "height": "341"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "stroke": "#FAB15F",
      "stroke-width": "3",
      "x": "11.5",
      "y": "11.5",
      "width": "497",
      "height": "318",
      "rx": "10"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M119.76991,310.751549 C117.925592,305.805426 115.230966,299.148935 111.686033,290.782075 C106.368634,278.231785 119.622523,269.710011 126.429188,281.907049 C142.568305,274.711685 144.761111,289.108271 135.789692,296.346843 C129.808746,301.172558 124.468819,305.974126 119.76991,310.751549 Z M56.474145,306.973204 C54.6312923,303.532918 52.0011154,298.928435 48.5836145,293.159754 C43.4573631,284.506732 51.8837716,276.611668 58.0229076,284.824866 C68.6314297,277.566103 71.7533765,287.959944 66.2103461,294.392335 C62.5149925,298.680595 59.2695921,302.874218 56.474145,306.973204 Z M189.958546,306.971377 C187.701036,303.502096 184.483302,298.856527 180.305342,293.034669 C174.038402,284.301883 184.032014,276.516408 191.507308,284.82304 C204.126188,277.704855 208.01414,288.15226 201.45742,294.513767 C197.086273,298.754771 193.253315,302.907308 189.958546,306.971377 Z M260.777797,311.00043 C257.147488,307.168132 252.066174,302.093674 245.533853,295.777055 C235.735373,286.302126 244.605919,273.279084 255.63725,281.846941 C267.681933,268.917517 275.325616,281.312847 269.895716,291.481401 C266.275783,298.260437 263.236477,304.76678 260.777797,311.00043 Z M385.772646,310.751549 C383.928328,305.805426 381.233702,299.148935 377.688769,290.782075 C372.37137,278.231785 385.625259,269.710011 392.431924,281.907049 C408.571042,274.711685 410.763847,289.108271 401.792428,296.346843 C395.811482,301.172558 390.471555,305.974126 385.772646,310.751549 Z M322.803222,306.973204 C320.96037,303.532918 318.330193,298.928435 314.912692,293.159754 C309.78644,284.506732 318.212849,276.611668 324.351985,284.824866 C334.960507,277.566103 338.082454,287.959944 332.539423,294.392335 C328.84407,298.680595 325.598669,302.874218 322.803222,306.973204 Z M455.961282,306.971377 C453.703772,303.502096 450.486038,298.856527 446.308078,293.034669 C440.041138,284.301883 450.03475,276.516408 457.510044,284.82304 C470.128924,277.704855 474.016876,288.15226 467.460156,294.513767 C463.089009,298.754771 459.256051,302.907308 455.961282,306.971377 Z",
      "fill": "#E7A255"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M399.161032,64.7511555 C401.007078,59.8057591 403.704228,53.1502456 407.252481,44.7846148 C412.574861,32.2361687 399.308558,23.7156457 392.495517,35.9108928 C376.341283,28.7165851 374.146423,43.1110567 383.126245,50.3485655 C389.112794,55.1735714 394.457723,59.9744347 399.161032,64.7511555 Z M462.516084,60.9733653 C464.360663,57.5335849 466.993303,52.9297779 470.414005,47.1619442 C475.545058,38.5101938 467.110757,30.6162891 460.965871,38.8282813 C450.347412,31.5705841 447.222541,41.9628988 452.770764,48.3943443 C456.469578,52.6819747 459.718019,56.8749817 462.516084,60.9733653 Z M328.906654,60.9715393 C331.166278,57.5027675 334.387027,52.8578804 338.5689,47.0368782 C344.841709,38.3053747 334.838737,30.5210435 327.356441,38.8264553 C314.725741,31.7093153 310.834147,42.1551865 317.397009,48.5157583 C321.772251,52.7561395 325.608799,56.9080665 328.906654,60.9715393 Z M258.02107,65 C261.654778,61.1682654 266.740852,56.0945524 273.279291,49.7788609 C283.08695,40.3053236 274.208095,27.2841945 263.166431,35.8507934 C251.110466,22.9232689 243.459624,35.3167782 248.894609,45.4838381 C252.517933,52.261878 255.560086,58.7672653 258.02107,65 Z M132.909142,64.7511555 C134.755188,59.8057591 137.452338,53.1502456 141.000591,44.7846148 C146.322971,32.2361687 133.056668,23.7156457 126.243627,35.9108928 C110.089393,28.7165851 107.894533,43.1110567 116.874355,50.3485655 C122.860903,55.1735714 128.205832,59.9744347 132.909142,64.7511555 Z M195.937547,60.9733653 C197.782126,57.5335849 200.414766,52.9297779 203.835468,47.1619442 C208.966521,38.5101938 200.53222,30.6162891 194.387334,38.8282813 C183.768875,31.5705841 180.644004,41.9628988 186.192226,48.3943443 C189.891041,52.6819747 193.139482,56.8749817 195.937547,60.9733653 Z M62.654764,60.9715393 C64.9143879,57.5027675 68.1351364,52.8578804 72.3170095,47.0368782 C78.5898191,38.3053747 68.5868469,30.5210435 61.1045507,38.8264553 C48.4738513,31.7093153 44.5822573,42.1551865 51.1451192,48.5157583 C55.5203605,52.7561395 59.3569088,56.9080665 62.654764,60.9715393 Z",
      "fill": "#E7A255"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ChalkboardSE-Regular, Chalkboard SE",
      "font-size": "36",
      "font-weight": "normal",
      "letter-spacing": "-0.5",
      "fill": "#E7A255"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "40.4809392",
      "y": "187"
    }
  }, [_vm._v("Love is Acceptance, Respect, ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "164.188674",
      "y": "238"
    }
  }, [_vm._v("and Support")])]), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ChalkboardSE-Regular, Chalkboard SE",
      "font-size": "48",
      "font-weight": "normal",
      "letter-spacing": "-0.666666687",
      "fill": "#E7A255"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "70.3099449",
      "y": "133"
    }
  }, [_vm._v("Love is not Abuse.")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be89260","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/gymSign.vue
// module id = 1010
// module chunks = 1